import axios from 'axios';
import { extractApiArray } from '../../../../utils/apiResponse';

export const getOrderId = order => Number(order.orderId ?? order.id);
export const isCancelledOrder = order =>
  (order.orderStatus?.databaseValue || order.orderStatus) === 'CANCELLED';

/** Numeric input can be either an order ID or an amount; #123 searches only by ID. */
export const buildAttachmentOrderQueries = (search = '') => {
  const value = search.trim();
  const idMatch = value.match(/^#\s*(\d+)$/);
  const compact = value.replace(/\s/g, '');
  const isNumber = /^\d+(?:[.,]\d{1,2})?$/.test(compact);
  if (idMatch || isNumber) {
    const number = Number(idMatch ? idMatch[1] : compact.replace(',', '.'));
    // Both filters are Java Integer fields on the order API.
    if (!Number.isInteger(number) || number > 2147483647) {
      throw new Error('Введіть ціле число від 0 до 2147483647.');
    }
    if (idMatch) return [{ orderId: number }];
    if (/^\d+$/.test(value)) return [{ orderId: number }, { discountedPrice: number }];
    return [{ discountedPrice: number }];
  }
  return value ? [{ clientSurname: value }] : [{}];
};

export const searchAttachmentOrders = async (search, signal) => {
  const responses = await Promise.all(
    buildAttachmentOrderQueries(search).map(filters =>
      axios.get('/api/v1/order', {
        params: {
          numberPerPage: 50,
          page: 1,
          orderPaymentStatusList: 0,
          orderPaymentTypeList: 'CREDIT_CARD',
          ...filters,
        },
        signal,
        headers: { Authorization: localStorage.getItem('token') },
      }),
    ),
  );
  const orders = new Map();
  responses.forEach(response =>
    extractApiArray(response).forEach(order => {
      const id = getOrderId(order);
      if (Number.isSafeInteger(id) && id > 0 && !isCancelledOrder(order)) orders.set(id, order);
    }),
  );
  return Array.from(orders.values());
};
